export enum PublicRoutes {
  CreateWorkspace = '/create-workspace',
  CreateNewPassword = '/create-new-password',
  Login = '/login',
  ResetPassword = '/reset-password',
  SessionExpired = '/session-expired',
  SignUp = '/sign-up',
}

export enum SetupWorkspaceRoutes {
  CheckInbox = 'check-inbox',
  Password = 'password',
  SignUp = 'sign-up',
}

export enum AuthorizedRoutes {
  ConnectConnection = 'connections/:name/connect',
  ManageConnection = 'connections/:name/manage',
  Settings = 'settings',
}

export enum SettingsRoutes {
  ApiKeys = 'api-keys',
  General = 'general',
  Members = 'members',
  Profile = 'profile',
}

export enum ConnectionSetupRoutes {
  ConnectionVerified = 'verified',
  SelectAccounts = 'select-accounts',
  Settings = 'settings',
  SignIn = 'sign-in',
}
